import { useState, useEffect } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import 'react-phone-input-2/lib/style.css'
import 'react-phone-input-2/lib/bootstrap.css'
import Select from 'react-select';
import { fetchData, fetchFormData, getTranslatedValue, hasSpecialCharacters, toasterrormsg, toastsuccessmsg } from '../../../../reusable'
import { ToastContainer } from 'react-toastify'
import { FileUploader } from 'react-drag-drop-files'
import { Tr } from '../../../../_metronic/i18n/Tr'
import { useLang } from '../../../../_metronic/i18n/Metronici18n'

export function PersonalDetails() {
  const t = Tr()
  const lang = useLang()
  const location = useLocation();
  const vendorId = (location.state as any)?.vendorId || '';

  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [disable, setDisable] = useState(false);
  const [ownerName, setOwnerName] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [businessRegistration, setBusinessRegistration] = useState() as any;
  // region list state start
  const [regionList, setRegionList] = useState([]);
  const [regionSelectedOptions, setRegionSelectedOptions] = useState<any>([]);
  const [zipCode, setZipCode] = useState("");
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [countryList, setCountryList] = useState([]);
  const [countrySelectedOptions, setCountrySelectedOptions] = useState<any>();

  // set error state
  const [error, setError] = useState([{
    ownerName: '',
    businessName: '',
    country: '',
    regionId: '',
    zipCode: '',
    addressLine1: '',
    businessRegistration: '',
  }])

  // remove validation function
  const removeError = (err: any) => {
    var tmp = [...error] as any;
    tmp[0][err] = "";
    setError(tmp);
  }

  // country list api call
  const countryListAPIcall = async () => {

    var res = await fetchData("public/countryList", [])

    if (res.status == "200") {
      var opt: any = []
      res.data.map((val: any) => {
        opt.push({ value: val.countryId, label: val.nicename })
      })

      setCountryList(opt)
    }
    else {
      toasterrormsg(res.message)
    }
  }
  //   region list api call
  const regionListAPIcall = async () => {

    var res = await fetchData("public/regionList", [])

    if (res.status == "200") {
      var opt: any = []
      res.data.map((val: any) => {
        opt.push({ value: val.regionId, label: getTranslatedValue(lang, val, '_name') })
      })

      setRegionList(opt)
    }
    else {
      toasterrormsg(res.message)
    }
  }
  // validation function
  const validate = () => {

    var isValid = true;
    var errorTmp = [...error];
    let firstErrorField = null;

    if (ownerName.trim() == "" || ownerName.trim() == null || ownerName.trim() == undefined) {
      errorTmp[0].ownerName = t('Owner Name Is Required');
      isValid = false;
      if (!firstErrorField) firstErrorField = 'ownerName';

    } else if (!hasSpecialCharacters(ownerName.trim())) {
      errorTmp[0].ownerName = t('Special Characters Is Not Allow');
      isValid = false;
      if (!firstErrorField) firstErrorField = 'ownerName';
    }
    if (businessName.trim() == "" || businessName.trim() == null || businessName.trim() == undefined) {
      errorTmp[0].businessName = t('Business Name Is Required');
      isValid = false;
      if (!firstErrorField) firstErrorField = 'businessName';
    }
    if (countrySelectedOptions == "" || countrySelectedOptions == null || countrySelectedOptions == undefined) {
      errorTmp[0].country = t('Country Is Required');
      isValid = false;
      if (!firstErrorField) firstErrorField = 'country';
    }
    if (regionSelectedOptions == "" || regionSelectedOptions == undefined || regionSelectedOptions == null) {
      errorTmp[0].regionId = t('Region Is Required');
      isValid = false;
    }
    if (addressLine1.trim() == "" || addressLine1.trim() == null || addressLine1.trim() == undefined) {
      errorTmp[0].addressLine1 = t('Address Line1 Is Required');
      isValid = false;
      if (!firstErrorField) firstErrorField = 'addressLine1';
    }
    if (zipCode.trim() == "" || zipCode.trim() == null || zipCode.trim() == undefined) {
      errorTmp[0].zipCode = t('Zip Code Is Required');
      isValid = false;
      if (!firstErrorField) firstErrorField = 'zipCode';
    }
    if (businessRegistration == undefined || businessRegistration == null || businessRegistration == undefined) {
      errorTmp[0].businessRegistration = t('Business Registration Is Required');
      isValid = false;
      if (!firstErrorField) firstErrorField = 'businessRegistration';

    }

    setError(errorTmp);
    // If there was a validation error, scroll to the first error field
    if (!isValid && firstErrorField) {
      const element = document.getElementById(firstErrorField);
      if (element) {
        element?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
    return isValid;
  }

  const fileTypes = ["JPEG", "JPG", "PNG", "PDF"];

  const handleBusinessRegistrationChange = (file: any) => {

    if (file) {
      if (!file.type.startsWith('image/') && file.type != "application/pdf") {
        // Invalid file type
        // Handle error or display a message
        toasterrormsg(t('Invalid file type. Please upload only image or pdf files.'))
        setBusinessRegistration(undefined)
        return;
      }
      // Handle business registration file change
      // For example:
      setBusinessRegistration(file);
      removeError('businessRegistration');
    } else {
      // Handle no file selected case
      console.error('No file selected.');
    }
  };
  const handleDivClick = (inputId: string) => {
    const inputElement = document.getElementById(inputId);
    if (inputElement) {
      inputElement.click();
    }
  }

  // add business details api call
  const addBusinessDetailsApi = async () => {
    if (validate()) {
      setDisable(true)
      setLoading(true);
      let param = new FormData()
      param.append('vendorId', vendorId)
      param.append('propertyOwnerName', ownerName)
      param.append('bussinessName', businessName)
      param.append('country', countrySelectedOptions.value)
      param.append('region', regionSelectedOptions.value)
      param.append('addressline1', addressLine1)
      param.append('addressline2', addressLine2)
      param.append('zipcode', zipCode)

      if (businessRegistration) {
        param.append('businessDocument', businessRegistration)
      }
      var response: any = await fetchFormData("public/businessInformation", param)
      if (response.status == "200") {
        toastsuccessmsg(t("Business Information Saved Successfully!"))
        const state = {
          vendorId: vendorId
        }
        setTimeout(() => {
          navigate("../businesspending/", { state });
          setDisable(false)
          setLoading(false)
        }, 1500);
      }
      else {
        toasterrormsg(response.message)
        setDisable(false)
        setLoading(false)
      }
    }
  }

  useEffect(() => {
    countryListAPIcall();
    regionListAPIcall();
  }, [])
  return (
    <>
      <ToastContainer />
      <div
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        id='kt_login_signup_form'
      // noValidate
      // onSubmit={formik.handleSubmit}
      >
        {/* begin::Heading */}
        <div className='text-center mb-11'>
          {/* begin::Title */}
          <h1 className='text-dark fw-bolder mb-3'>{t('Business Information')}</h1>
          {/* end::Title */}
        </div>
        {/* end::Heading */}

        {/* begin::Form group Firstname */}
        <div className="dropzone border-success bg-light-success mb-2" id="kt_ecommerce_add_reject_reason">
          <div className="dz-message needsclick">
            {/* <!--begin::Icon--> */}
            <i className="fas fa-info-circle text-success fs-5 mt-1"></i>
            <div className="ms-4">
              <span className="fs-7 fw-semibold text-gray-600">{t("Iltimos, biz sizning arizangizni qabul qilishimiz uchun barcha ma'lumotlar haqqoniyligiga va to'g'ri kiritilganligiga ishonch hosil qiling. Noto'g'ri kiritilgan yoki soxta ma'lumotlarga ega arizalar bekor qilinadi.")}</span>
            </div>
          </div>
        </div>
        <div className='fv-row my-8'>
          <label className='form-label fw-bolder text-dark fs-6 required'>{t('Property Owner Name')}</label>
          {/* <!--begin::Input--> */}
          <input type="text" name="ownerName" id='ownerName' className="form-control mb-2" placeholder={t("Property Owner Name")} value={ownerName} onChange={(e) => { setOwnerName(e.target.value); removeError("ownerName"); }} />
          {/* <!--end::Input--> */}
          <div className='text-danger fw-bold'>{error[0].ownerName}</div>
        </div>
        {/* end::Form group */}
        <div className='fv-row mb-8'>
          {/* begin::Form group Lastname */}
          <label className='form-label fw-bolder text-dark fs-6 required'>{t('Business Name')}</label>
          {/* <!--begin::Input--> */}
          <input type="text" name="businessName" id='businessName' className="form-control mb-2" placeholder={t("Business Name")} value={businessName} onChange={(e) => { setBusinessName(e.target.value); removeError("businessName"); }} />
          {/* <!--end::Input--> */}
          <div className='text-danger fw-bold'>{error[0].businessName}</div>
        </div>
        {/* begin::Form group Email */}
        <div className='fv-row mb-8'>
          <label className='form-label fw-bolder text-dark fs-6 required'>{t('Country')}</label>
          {/* <!--begin::Input--> */}
          <Select
            name='country'
            id='country'
            placeholder={t('Select Country')}
            isSearchable={true}
            options={countryList}
            value={countrySelectedOptions}
            onChange={(e: any) => { setCountrySelectedOptions(e); removeError("country"); }}
          />
          {/* <!--end::Input--> */}
          <div className='text-danger fw-bold'>{error[0].country}</div>
        </div>
        <div className="fv-row mb-8 mt-4">
          <label className="required fs-4 form-label">{t('Region')}</label>
          {/* <!--end::Label--> */}
          {/* <!--begin::Input--> */}
          <Select
            name='region[]'
            id='regionListId'
            placeholder={t('Select Region')}
            isSearchable={true}
            options={regionList}
            value={regionSelectedOptions}
            onChange={(e: any) => { setRegionSelectedOptions(e); removeError("regionId"); }}
          />
          <div className='text-danger fw-bold'>{error[0].regionId}</div>
        </div>
        <div className='fv-row mb-8'>
          <label className='form-label fw-bolder text-dark fs-6 required'>{t('Address Line 1')}</label>
          {/* <!--begin::Input--> */}
          <input type="text" name="addressLine1" id='addressLine1' className="form-control mb-2" placeholder={t("Address Line 1")} value={addressLine1} onChange={(e) => { setAddressLine1(e.target.value); removeError("addressLine1"); }} />
          {/* <!--end::Input--> */}
          <div className='text-danger fw-bold'>{error[0].addressLine1}</div>
        </div>
        <div className='fv-row mb-8'>
          <label className='form-label fw-bolder text-dark fs-6'>{t('Address Line 2 (optional)')}</label>
          {/* <!--begin::Input--> */}
          <input type="text" name="addressLine2" id='addressLine2' className="form-control mb-2" placeholder={t("Address Line 2")} value={addressLine2} onChange={(e) => { setAddressLine2(e.target.value); removeError("addressLine2"); }} />
          {/* <!--end::Input--> */}
        </div>
        <div className='fv-row mb-8'>
          <label className='form-label fw-bolder text-dark fs-6 required'>{t('Zip Code')}</label>
          {/* <!--begin::Input--> */}
          <input type="text" name="zipCode" id='zipCode' className="form-control mb-2" placeholder={t("Zip Code")} value={zipCode} onChange={(e) => { setZipCode(e.target.value); removeError("zipCode"); }} />
          {/* <!--end::Input--> */}
          <div className='text-danger fw-bold'>{error[0].zipCode}</div>
        </div>
        <div className='fv-row mb-8'>
          <div className='mt-5' id='businessRegistration'>
            <FileUploader
              multiple={false}
              handleChange={handleBusinessRegistrationChange}
              name="businessRegistration"
              types={fileTypes}
              classes="w-100"
            >
              <div className="dropzone border-success bg-light-success dz-clickable" id="kt_ecommerce_add_business_certificate" onClick={() => handleDivClick('businessRegistration')}>

                <div className="dz-message needsclick">
                  {/* <!--begin::Icon--> */}
                  <i className="ki-outline ki-file-up text-success fs-3x"></i>
                  {/* <!--end::Icon--> */}
                  {/* <!--begin::Info--> */}
                  <div className="ms-4">
                    <h3 className="fs-5 fw-bold text-gray-900 mb-1">{t('Upload Business Registration')}</h3>
                    <span className="fs-7 fw-semibold text-gray-500">{t('Drag & Drop or choose files from computer')}</span>
                  </div>
                  {/* <!--end::Info--> */}
                </div>
              </div>
            </FileUploader>
            {/* <!--begin::Message--> */}
          </div>
          <div className='text-danger fw-bold'>{error[0].businessRegistration}</div>
          <div className="row mt-3">
            {businessRegistration && (
              <div className="col-lg-12 col-3 d-flex flex-column mb-5">
                {
                  businessRegistration && businessRegistration.type.startsWith('image/') ? (
                    <div className='shadow-sm rounded-4' style={{ maxWidth: "fit-content", width: "300px", height: "200px" }}>
                      <a href={URL.createObjectURL(businessRegistration)} target="_blank">
                        <img className='p-2 rounded-4' src={URL.createObjectURL(businessRegistration)} width="100%" style={{ width: "300px", height: "200px" }} />
                      </a>
                    </div>
                  ) : (
                    <div className='card h-200px shadow-sm rounded-4 w-300px'>
                      <div className='card-body d-flex justify-content-center text-center flex-column p-8'>
                        <a href={URL.createObjectURL(businessRegistration)} target='_blank' className='text-gray-800 text-hover-primary d-flex flex-column'>
                          <div className='symbol symbol-75px mb-6'>
                            <img src={toAbsoluteUrl('/media/svg/files/pdf.svg')} alt='pdf' />
                          </div>
                        </a>
                      </div>
                    </div>
                  )
                }
              </div>
            )}
          </div>
        </div>
        {/* begin::Form group */}
        <div className='text-center'>
          <button type="button" disabled={disable} className="btn btn-lg btn-primary w-100 mb-5" onClick={addBusinessDetailsApi}>
            <span className="indicator-label">{t('Submit')}</span>
            {loading && (
              <span className="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
            )}
          </button>
          <Link to='/auth/login'>
            <button
              type='button'
              id='kt_login_signup_form_cancel_button'
              className='btn btn-lg btn-light-primary w-100 mb-5'
            >
              {t('Cancel')}
            </button>
          </Link>
        </div>
        {/* end::Form group */}
      </div>
    </>
  )
}
